import {
  DesignGallery,
  Group,
} from 'apps/shared/scripts/components';

import { Step, StepProps } from '../../components';
import { FORM_FIELDS } from '../../components/OnboardingForm';

type Props = Omit<StepProps, 'heading' | 'subheading' | 'name' | 'percentage'>;

const OnboardingDesignContainer = (props: Props) => {
  return (
    <Step
      {...props}
      heading="Choose a design"
      subheading="Add a splash of color to the card background"
      name={FORM_FIELDS.DESIGN_ID.name}
      percentage={75}
    >
      <Group errors={props.errors} validate={FORM_FIELDS.DESIGN_ID.name}>
        <DesignGallery control={props.control} name={FORM_FIELDS.DESIGN_ID.name} />
      </Group>
    </Step>
  );
};

OnboardingDesignContainer.displayName = 'OnboardingDesignContainer';

export default OnboardingDesignContainer;
